var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{staticClass:"fill-height justify-center",attrs:{"fluid":""}},[_c('div',{staticClass:"card"},[_c('KshaaAbout',{attrs:{"shortDescription":"DevOps / Student @ LU / Cyclist"}}),_c('KshaaSocial')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }